module.exports = __webpack_public_path__ + "components/blogs-header/static/header--huge-b2361132445ad4abc3409197f3159d4b.jpg";